/**
 * Google Ads Integration
 * Handles Google Ads conversion tracking with Enhanced Conversions.
 * Works alongside GA4 integration.
 *
 * Standalone version for co-aurora.
 * Ported from shopper/src/scripts/lib/integrations/google-ads.js
 */
(function() {
  'use strict';

  function GoogleAds(config) {
    this.conversionId = null;
    this.conversionLabels = {};
    window.TrackingBase.call(this, Object.assign({
      name: 'GoogleAds',
      enableEnhancedConversions: true
    }, config));
  }

  GoogleAds.prototype = Object.create(window.TrackingBase.prototype);
  GoogleAds.prototype.constructor = GoogleAds;

  /* ---- Initialize ---- */

  GoogleAds.prototype.initialize = function() {
    var settings = window.theme && window.theme.settings;
    this.conversionId = settings && settings.google_ads_conversion_id;

    if (!this.conversionId || this.conversionId === 'undefined') {
      this.log('Google Ads conversion ID not configured - disabled');
      this.config.enabled = false;
      return;
    }

    this.conversionLabels = {
      'purchase': settings.google_ads_conversion_label_purchase,
      'begin_checkout': settings.google_ads_conversion_label_checkout,
      'add_to_cart': settings.google_ads_conversion_label_add_to_cart,
      'page_view': settings.google_ads_conversion_label_page_view
    };

    this.log('Google Ads initialized', {
      conversionId: this.conversionId,
      events: Object.keys(this.conversionLabels).filter(function(k) { return !!this.conversionLabels[k]; }.bind(this))
    });

    var self = this;
    this._waitForGtag().then(function() {
      if (window.gtag) {
        window.gtag('config', self.conversionId, { 'allow_enhanced_conversions': true });
      }
    });

    this._setupAjaxEventListeners();
    this._attachEventListeners();
  };

  GoogleAds.prototype._waitForGtag = function() {
    return new Promise(function(resolve) {
      var attempts = 0;
      (function check() {
        if (window.gtag || attempts >= 100) { resolve(); return; }
        attempts++;
        setTimeout(check, 100);
      })();
    });
  };

  /* ---- Conversion tracking ---- */

  GoogleAds.prototype.track = function(eventName, eventData, options) {
    this.trackConversion(eventName, eventData, options);
  };

  GoogleAds.prototype.trackConversion = function(eventName, eventData, options) {
    eventData = eventData || {};
    if (!this.config.enabled || !window.gtag) return;

    var label = this.conversionLabels[eventName];
    if (!label || label === 'undefined') return;

    var conversionData = {
      'send_to': this.conversionId + '/' + label,
      'value': eventData.value,
      'currency': eventData.currency || 'USD',
      'transaction_id': eventData.transaction_id || eventData.transactionId
    };

    var userData = this._getEnhancedConversionsData();
    if (userData && Object.keys(userData).length > 0) {
      conversionData.user_data = userData;
    }

    window.gtag('event', 'conversion', conversionData);
    this.log('Conversion tracked: ' + eventName, { send_to: conversionData.send_to });
  };

  /* ---- Enhanced Conversions ---- */

  GoogleAds.prototype._getEnhancedConversionsData = function() {
    var userData = {};

    /* Client IP */
    if (window.AttributionManager) {
      var sess = window.AttributionManager.getSessionData();
      if (sess && sess.client_ip) {
        userData.ip_address = sess.client_ip;
        userData.user_agent = navigator.userAgent;
      }
    }

    /* Customer data */
    var customer = window.theme && window.theme.customer;
    if (customer && customer.id) {
      if (customer.email) userData.email = customer.email;
      if (customer.phone) {
        var phone = customer.phone;
        if (phone.length === 10 && phone.charAt(0) !== '+') phone = '+1' + phone;
        else if (phone.charAt(0) !== '+' && phone.length > 10) phone = '+' + phone;
        userData.phone_number = phone;
      }
      if (customer.first_name) userData.first_name = customer.first_name;
      if (customer.last_name) userData.last_name = customer.last_name;
      if (customer.street) userData.street = customer.street;
      if (customer.city) userData.city = customer.city;
      if (customer.state) userData.region = customer.state;
      if (customer.postal_code) userData.postal_code = customer.postal_code;
      if (customer.country) userData.country = customer.country.toUpperCase();
    }

    return userData;
  };

  /* Export */
  window.TrackingGoogleAds = GoogleAds;
})();
